var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffsetIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1a7 7 0 110 14v-1.5c1.469 0 2.85-.572 3.889-1.611S15.5 9.469 15.5 8c0-1.469-.572-2.85-1.611-3.889S11.469 2.5 10 2.5c-1.469 0-2.85.572-3.889 1.611A5.455 5.455 0 004.591 7H7.5L4 11 .5 7h2.571A7.001 7.001 0 0110 1zm3 6v2H9V4h2v3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffsetIcon);
export default __webpack_public_path__ + "static/media/offset-icon.259a4871b8929f60b2a2181f8c4c304f.svg";
export { ForwardRef as ReactComponent };